import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ContactIdContainer, IDButton } from "./ContactId.styled";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../ContactList.styled";
import AddEditContact from "../../../AddEditContact/AddEditContact";

const ContactId = (props) => {
  const { t, data, id, status, updateRefeshStatus, type } = props;
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditContactPopupVisible, setIsEditContactPopupVisible] =
    useState(false);

  const onContactIdClick = () => {
    setIsEditContactPopupVisible(true);
  };

  const closeContactEditPopup = () => {
    setIsEditMode(false);
    setIsViewMode(true);
    setIsEditContactPopupVisible(false);
  };

  const togglePopUp = () => {
    setIsEditMode(!isEditMode);
    setIsViewMode(!isViewMode);
  };

  return (
    <>
      {status === 1 && (
        <DivBackgroundFullOpacity>
          <ContactIdContainer>
            <IDButton onClick={onContactIdClick}>{data}</IDButton>
          </ContactIdContainer>
        </DivBackgroundFullOpacity>
      )}
      {status !== 1 && (
        <DivBackgroundLowOpacity>
          <ContactIdContainer>
            <IDButton onClick={onContactIdClick}>{data}</IDButton>
          </ContactIdContainer>
        </DivBackgroundLowOpacity>
      )}
      {isEditContactPopupVisible && (
        <AddEditContact
          id={id}
          title={t("CONTACT") + " #" + id}
          onClose={closeContactEditPopup}
          isEditMode={isEditMode}
          isViewMode={isViewMode}
          togglePopUp={togglePopUp}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </>
  );
};

ContactId.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ContactId);
